import React, { useEffect, useState } from "react";
import { Card, Form, Button, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
  faEnvelope,
  faLink,
  faVideo,
  faSearch,
  faComment,
} from "@fortawesome/free-solid-svg-icons";
import {
  faLinkedin,
  faTwitterSquare,
} from "@fortawesome/free-brands-svg-icons";
import firebase from "firebase";
import Avatar from "react-avatar";
import parse from "html-react-parser";
import { connect } from "react-redux";
import { orderBy, escapeRegExp } from "lodash";
import { useParams } from "react-router";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDocument, useCollection } from "react-firebase-hooks/firestore";

import LeftBar from "./LeftBar";
import NavBar from "./NavBar";
import EventChat from "./EventChat";

import { postData } from "../../../utils/index";
import { sendEmail } from "../../../utils/index";
import { API_BASE_URL, EVENT_PARTICIPANTS } from "../../../config";
toast.configure();

function PeopleNetwork(props) {
  const { id } = useParams();
  const { currentEvent, event_id, darkTheme } = props;

  const currentUser = firebase.auth().currentUser;

  // STATES
  const [showChat, setShowChat] = useState(false);
  const [show, setShow] = useState(false);
  const [currentProfile, setCurrentProfile] = useState(null);
  const [networkingMessage, setNetworkingMessage] = useState(
    `I'd like to join your network. `
  );
  const [networkingMessageErr, setNetworkingMessageErr] = useState(false);
  const [showNM, setShowNM] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [regex, setRegex] = useState("");
  const [currentSortCriteria, setCurrentSortCriteria] = useState(null);
  const [participantList, setParticipantList] = useState([]);
  const [fetchingParticipants, setFetchingParticipants] = useState(true);

  // FUNCTIONS
  const [myDoc, loadingMyDoc, errorMyDoc] = useDocument(
    currentUser && firebase.firestore().collection("users").doc(currentUser.uid)
  );

  // const [attendeesSnapshot, loading, error] = useCollection(
  //   firebase
  //     .firestore()
  //     .collection(`/events/${currentEvent?.id}/users`)
  //     .orderBy("firstName")
  // );

  // let participantList = attendeesSnapshot?.docs.map((doc) => ({
  //   ...doc.data(),
  //   displayName: doc.data().firstName + " " + doc.data().lastName,
  //   id: doc.id,
  // }));

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleCloseNM = () => {
    setShowNM(false);
    setNetworkingMessage(`I'd like to join your network.`);
  };
  const handleShowNM = () => setShowNM(true);

  const openProfile = (attendee) => {
    setCurrentProfile(attendee);
    handleShow();
  };

  const [eventSnapshot, loadingEvent, errorEvent] = useDocument(
    currentProfile &&
      firebase.firestore().collection("users").doc(currentProfile.uid)
  );

  const getWhetherURLOrLocalFile = (file) => {
    if (!file.name) {
      return file;
    } else {
      return URL.createObjectURL(file);
    }
  };

  // sorting and filtering

  // participantList =
  //   currentSortCriteria !== null
  //     ? orderBy(
  //         participantList,
  //         currentSortCriteria.value.split("-")[0],
  //         currentSortCriteria.sortOrder
  //       )
  //     : participantList;

  // const sortOptions = [
  //   {
  //     value: "firstName-asc",
  //     label: `First name (Ascending)`,
  //     sortOrder: "asc",
  //   },
  //   {
  //     value: "firstName-desc",
  //     label: `First name (Descending)`,
  //     sortOrder: "desc",
  //   },
  //   {
  //     value: "lastName-asc",
  //     label: `Last name (Ascending)`,
  //     sortOrder: "asc",
  //   },
  //   {
  //     value: "lastName-desc",
  //     label: `Last name (Descending)`,
  //     sortOrder: "desc",
  //   },
  // ];

  const handleSearch = (e) => {
    let value = e.target.value;
    setSearchTerm(e.target.value);
    const reg = escapeRegExp(searchTerm);
    // console.log(reg,"Reg")
    const regex = new RegExp(reg, "gi");
    setRegex(regex);
    //this.setState({ regex: regex })
  };

  const submitNetworkingRequest = async (e) => {
    e.preventDefault();

    if (currentProfile === null) {
      alert("Oops");
    }

    if (networkingMessage === "" || networkingMessage === null) {
      return;
    }

    await postData(`${API_BASE_URL}/data/push`, {
      point_type: "networking.request",
      data_properties: {
        event_id: currentEvent?.id,
        to_email: currentProfile.email,
        from_email: currentUser.email,
        message: networkingMessage,
        from_user_id: currentUser.uid,
        to_user_id: currentProfile.uid,
      },
    });

    try {
      await sendEmail({
        to: currentProfile.email,
        subject: `Start a conversation with ${
          !loadingMyDoc && myDoc.data().displayName
        } - ${currentEvent?.event_details[`EN`]?.event_name}`,
        content: `<!DOCTYPE HTML PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office"><head> <!--[if gte mso 9]> <xml> <o:OfficeDocumentSettings> <o:AllowPNG/> <o:PixelsPerInch>96</o:PixelsPerInch> </o:OfficeDocumentSettings> </xml> <![endif]--><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1.0"><meta name="x-apple-disable-message-reformatting"> <!--[if !mso]><!--><meta http-equiv="X-UA-Compatible" content="IE=edge"> <!--<![endif]--><title></title><style type="text/css">a{color:#161a39;text-decoration:underline}@media only screen and (min-width: 620px){.u-row{width:600px !important}.u-row .u-col{vertical-align:top}.u-row .u-col-100{width:600px !important}}@media (max-width: 620px){.u-row-container{max-width:100% !important;padding-left:0px !important;padding-right:0px !important}.u-row .u-col{min-width:320px !important;max-width:100% !important;display:block !important}.u-row{width:calc(100% - 40px) !important}.u-col{width:100% !important}.u-col>div{margin:0 auto}}body{margin:0;padding:0}table,tr,td{vertical-align:top;border-collapse:collapse}p{margin:0}.ie-container table, .mso-container table{table-layout:fixed}*{line-height:inherit}a[x-apple-data-detectors='true']{color:inherit !important;text-decoration:none !important}</style><!--[if !mso]><!--><link href="https://fonts.googleapis.com/css?family=Lato:400,700&display=swap" rel="stylesheet" type="text/css"> <!--<![endif]--></head><body class="clean-body" style="margin: 0;padding: 0;-webkit-text-size-adjust: 100%;background-color: #f9f9f9"> <!--[if IE]><div class="ie-container"><![endif]--> <!--[if mso]><div class="mso-container"><![endif]--><table style="border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;min-width: 320px;Margin: 0 auto;background-color: #f9f9f9;width:100%" cellpadding="0" cellspacing="0"><tbody><tr style="vertical-align: top"><td style="word-break: break-word;border-collapse: collapse !important;vertical-align: top"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td align="center" style="background-color: #f9f9f9;"><![endif]--><div class="u-row-container" style="padding: 0px;background-color: #f9f9f9"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #f9f9f9;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: #f9f9f9;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #f9f9f9;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:15px;font-family:'Lato',sans-serif;" align="left"><table height="0px" align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 1px solid #f9f9f9;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%"><tbody><tr style="vertical-align: top"><td style="word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%"> <span>&#160;</span></td></tr></tbody></table></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><div class="u-row-container" style="padding: 0px;background-color: transparent"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #ffffff;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:25px 0px;font-family:'Lato',sans-serif;" align="left"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 20px; padding-left: 30px;" align="left"><img align="left" border="0" src=${
          currentEvent?.event_details?.featured_image
        } alt="Image" title="Image" style="outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both; display: inline-block !important;border: none;height: auto;float: none;width: 53%;max-width: 307.4px; border-radius: 4px;" width="307.4" /></td></tr></table></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><div class="u-row-container" style="padding: 0px;background-color: transparent"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #ffffff;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:10px 40px 30px;font-family:'Lato',sans-serif;" align="left"><div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;"><p style="font-size: 14px; line-height: 140%;"><span style="font-size: 18px; line-height: 25.2px; color: #34495e; font-family: helvetica, sans-serif;">Hi ${
          currentProfile.firstName
        }, </span></p><p style="font-size: 14px; line-height: 140%;">&nbsp;</p><p style="font-size: 14px; line-height: 140%;"><span style="font-family: helvetica, sans-serif; font-size: 18px; line-height: 25.2px; color: #34495e;">${networkingMessage}<br/><br/> 
        ${
          !loadingMyDoc && myDoc.data().displayName
            ? `${myDoc.data().displayName} <br/> `
            : ""
        }
        ${!loadingMyDoc && myDoc.data().bio ? `${myDoc.data().bio} <br/> ` : ""}
        ${
          !loadingMyDoc && myDoc.data().linkedinURL
            ? `${myDoc.data().linkedinURL} <br/> `
            : ""
        }
        ${
          !loadingMyDoc && myDoc.data().twitterURL
            ? `${myDoc.data().twitterURL} <br/> `
            : ""
        }
        ${
          !loadingMyDoc && myDoc.data().websiteURL
            ? `${myDoc.data().websiteURL} <br/> `
            : ""
        }
        <br/>Reply to this email to continue the conversation.</span></p></div></td></tr></tbody></table><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:0px 40px;font-family:'Lato',sans-serif;" align="left"><div align="left"> <!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="border-spacing: 0; border-collapse: collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;font-family:'Lato',sans-serif;"><tr><td style="font-family:'Lato',sans-serif;" align="left"><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="" style="height:51px; v-text-anchor:middle; width:253px;" arcsize="2%" stroke="f" fillcolor="#3598db"><w:anchorlock/><center style="color:#FFFFFF;font-family:'Lato',sans-serif;"><![endif]--> <a href="https://platform.igesia.co/event/${
          currentEvent?.slug
        }/dashboard/" target="_blank" style="box-sizing: border-box;display: inline-block;font-family:'Lato',sans-serif;text-decoration: none;-webkit-text-size-adjust: none;text-align: center;color: #FFFFFF; background-color: #3598db; border-radius: 4px; -webkit-border-radius: 4px; -moz-border-radius: 4px; width:auto; max-width:100%; overflow-wrap: break-word; word-break: break-word; word-wrap:break-word; mso-border-alt: none;"> <span style="display:block;padding:15px 40px;line-height:120%;"><strong><span style="font-size: 18px; line-height: 21.599999999999998px;">Visit Event Dashboard</span></strong></span> </a> <!--[if mso]></center></v:roundrect></td></tr></table><![endif]--></div></td></tr></tbody></table><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:40px 40px 30px;font-family:'Lato',sans-serif;" align="left"><div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;"><p style="font-size: 14px; line-height: 140%;"><span style="color: #888888; font-size: 14px; line-height: 19.599999999999998px; font-family: helvetica, sans-serif;"><em><span style="line-height: 19.599999999999998px; font-size: 14px;">Event powered by <a href="http://events.igesia.co/" target="_blank" rel="noopener">igesia</a></span></em></span></p><p style="font-size: 14px; line-height: 140%;"><span style="font-family: helvetica, sans-serif; font-size: 14px; line-height: 19.599999999999998px;">&copy; [igesia] 2021. All rights reserved.</span><br /><span style="color: #888888; font-size: 14px; line-height: 19.599999999999998px; font-family: helvetica, sans-serif;"><em><span style="font-size: 16px; line-height: 22.4px;">&nbsp;</span></em></span></p></div></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><div class="u-row-container" style="padding: 0px;background-color: transparent"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #f9f9f9;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #f9f9f9;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:0px 40px 30px 20px;font-family:'Lato',sans-serif;" align="left"><div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;"></div></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><!--[if (mso)|(IE)]></td></tr></table><![endif]--></td></tr></tbody></table> <!--[if mso]></div><![endif]--> <!--[if IE]></div><![endif]--></body></html>`,

        from: `"${currentUser.displayName} | Igesia" <noreply@igesia.co>`,
        replyTo: currentUser.email,
      });
      toast.success("Networking request successfully sent", {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
        autoClose: 3000,
      });
      handleCloseNM();
    } catch (e) {
      console.error(e, "error in sending Networking request");
    }
  };

  const UserAvatar = ({ imgSize, attendee }) => {
    const [userDoc, loadingDoc, errorDoc] = useDocument(
      attendee && firebase.firestore().collection("users").doc(attendee.uid)
    );

    let img_size = imgSize ? imgSize : 25;

    if (loadingDoc)
      return (
        <Avatar
          name={attendee.firstName + " " + attendee.lastName}
          round={true}
          size={img_size}
          textSizeRatio={1.75}
          className="mr-3"
          onClick={() => openProfile(attendee)}
          style={{ cursor: "pointer" }}
        />
      );

    if (!loadingDoc)
      return userDoc.data().avatar.indexOf("solo-icon.svg") > -1 ? (
        <Avatar
          name={attendee.firstName + " " + attendee.lastName}
          round={true}
          size={img_size}
          textSizeRatio={1.75}
          className="mr-3"
          onClick={() => openProfile(attendee)}
          style={{ cursor: "pointer" }}
        />
      ) : (
        <img
          title={attendee.firstName + " " + attendee.lastName}
          src={userDoc.data().avatar}
          className="img-fluid rounded-circle mr-3"
          style={{ height: img_size, width: img_size, cursor: "pointer" }}
          onClick={() => openProfile(attendee)}
        />
      );
  };

  useEffect(async () => {
    if (currentEvent?.id) {
      const response = await postData(`${API_BASE_URL}${EVENT_PARTICIPANTS}`, {
        event_id: currentEvent?.id,
      });

      if (response.status === 200) {
        const { data } = response;
        const participant_list = data.participantList?.map((item) => {
          return {
            ...item,
            displayName: item.firstName + " " + item.lastName,
          };
        });

        setParticipantList(participant_list);
        setFetchingParticipants(false);
      }
    }
  }, []);

  return (
    <React.Fragment>
      <div className="h-100" data-theme={darkTheme ? "dark" : "light"}>
        <LeftBar mobile />
        <div className="container-fluid h-100" style={{ overflow: "hidden" }}>
          <NavBar />
          <div className="row" style={{ height: "93vh", overflow: "hidden" }}>
            <LeftBar />
            <div className="col-md-7 h-100  " style={{ overflow: "scroll" }}>
              <Card
                data-theme={darkTheme ? "dark" : "light"}
                className="h-100 border-0 rounded-0"
                style={{ minHeight: "100%" }}
              >
                {props.headerComponent ? (
                  <Card.Header className="p-0">
                    {props.headerComponent}
                  </Card.Header>
                ) : (
                  <Card.Header>
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1 ">
                        <p className="mb-0 font-weight-bold small text-secondary">
                          People
                        </p>
                      </div>
                    </div>
                  </Card.Header>
                )}
                <div
                  className="position-sticky"
                  data-theme={darkTheme ? "dark" : "light"}
                >
                  <div className="d-flex border-left border-right border-bottom">
                    <div className="flex-grow-1">
                      <div className="d-flex align-items-center search-bar">
                        <div
                          style={{ margin: 0 }}
                          className="p-2 border-0 rounded"
                        >
                          <FontAwesomeIcon
                            icon={faSearch}
                            size="sm"
                            color="#aeaeae"
                          />
                        </div>
                        <div className="flex-grow-1">
                          <Form.Control
                            type="text"
                            id="participantsSearch"
                            className={
                              darkTheme
                                ? "text-white bg-dark border-0 px-0 rounded"
                                : "text-dark bg-white border-0 px-0 rounded"
                            }
                            onChange={handleSearch}
                            placeholder={"Search by name"}
                            value={searchTerm}
                            style={{ margin: 0 }}
                          />
                        </div>
                        {searchTerm.length > 0 && (
                          <div
                            className="py-2 pl-2 pr-3 bg-white"
                            onClick={() => setSearchTerm("")}
                          >
                            <FontAwesomeIcon icon={faTimes} color="#aeaeae" />
                          </div>
                        )}
                      </div>
                    </div>
                    {/* <div className="" style={{zIndex:"10"}}>
                      <Dropdown className="p-2" style={{ cursor: "pointer" , zIndex:10}}>
                        <Dropdown.Toggle as="div" id="dropdown-basic" style={{ zIndex: 10}}>
                          <FontAwesomeIcon
                            icon={faFilter}
                            className="text-muted"
                          />
                        </Dropdown.Toggle>
                        <Dropdown.Menu style={{ zIndex:"10"}}>
                          {sortOptions.map((item, key) => (
                            <Dropdown.Item
                              onClick={() => setCurrentSortCriteria(item)}
                            >
                              {item.label}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div> */}
                    {/* <div className="col-md-6">
              <Dropdown>
                <Dropdown.Toggle as="div" id="dropdown-basic">
                  <FontAwesomeIcon icon={faFilter} className="text-muted" />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {sortOptions.map((item, key) => (
                    <Dropdown.Item onClick={() => setCurrentSortCriteria(item)}>
                      {item.label}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
              <Select
                placeholder="Sort"
                options={sortOptions}
                defaultValue={sortOptions[0]}
                onChange={(e) => setCurrentSortCriteria(e)}
                className="w-100 mt-md-0 mt-3"
              ></Select>
            </div> */}
                  </div>
                </div>
                <Card.Body
                  className="m-0 p-0"
                  style={{ overflowY: "auto" }}
                  data-theme={darkTheme ? "dark" : "light"}
                >
                  {searchTerm && searchTerm.trim().length ? (
                    <div className="mt-3 row">
                      {participantList
                        ?.filter((item) => {
                          return item.displayName?.match(regex);
                        })
                        ?.map((attendee, key) => (
                          <div className="col-md-6 mb-4 col-12" key={key}>
                            <div className="card   rounded">
                              <div
                                className="d-flex h-100 w-100 align-items-center p-3"
                                data-theme={darkTheme ? "dark" : "light"}
                              >
                                <UserAvatar attendee={attendee} />
                                <div
                                  className="flex-grow-1"
                                  onClick={() => openProfile(attendee)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <p className="text-s-11 mb-0 text-left text-capitalize">
                                    {attendee.firstName +
                                      " " +
                                      attendee.lastName}{" "}
                                    {attendee.uid === currentUser.uid && (
                                      <span className="text-lowercase">
                                        (me)
                                      </span>
                                    )}
                                  </p>
                                </div>
                                {currentEvent?.people_enabled ? (
                                  <div>
                                    {attendee.uid === currentUser.uid ? (
                                      <></>
                                    ) : (
                                      <Button
                                        variant="outline-primary"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleShowNM();
                                          setCurrentProfile(attendee);
                                        }}
                                        className="btn-sm ml-auto"
                                        title="Send networking request"
                                      >
                                        <FontAwesomeIcon
                                          icon={faEnvelope}
                                          className="mr-1"
                                        />
                                        <span>Message</span>{" "}
                                      </Button>
                                    )}
                                  </div>
                                ) : (
                                  <Button
                                    variant="outline-primary"
                                    disabled={true}
                                    className="btn-sm ml-auto"
                                    title="Send networking request"
                                  >
                                    <FontAwesomeIcon
                                      icon={faEnvelope}
                                      className="mr-1"
                                    />
                                    <span>Message</span>{" "}
                                  </Button>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  ) : (
                    <div className="mt-3 row">
                      {participantList?.map((attendee, key) => (
                        <div className="col-md-6 mb-4 col-12" key={key}>
                          <div className="card rounded">
                            <div
                              className="d-flex h-100 w-100 align-items-center p-3"
                              data-theme={darkTheme ? "dark" : "light"}
                            >
                              <UserAvatar attendee={attendee} />
                              <div
                                className="flex-grow-1"
                                onClick={() => openProfile(attendee)}
                                style={{ cursor: "pointer" }}
                              >
                                <p className="text-s-11 mb-0 text-left text-capitalize">
                                  {attendee.firstName + " " + attendee.lastName}{" "}
                                  {attendee.uid === currentUser.uid && (
                                    <span className="text-lowercase">(me)</span>
                                  )}
                                </p>
                              </div>
                              {currentEvent?.people_enabled ? (
                                <div>
                                  {attendee.uid === currentUser.uid ? (
                                    <></>
                                  ) : (
                                    <Button
                                      variant="outline-primary"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleShowNM();
                                        setCurrentProfile(attendee);
                                      }}
                                      className="btn-sm ml-auto"
                                      title="Send networking request"
                                    >
                                      <FontAwesomeIcon
                                        icon={faEnvelope}
                                        className="mr-1"
                                      />
                                      <span>Message</span>{" "}
                                    </Button>
                                  )}
                                </div>
                              ) : (
                                <Button
                                  variant="outline-primary"
                                  disabled={true}
                                  className="btn-sm ml-auto"
                                  title="Send networking request"
                                >
                                  <FontAwesomeIcon
                                    icon={faEnvelope}
                                    className="mr-1"
                                  />
                                  <span>Message</span>{" "}
                                </Button>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                  <div className="p-3">
                    {fetchingParticipants ? (
                      <p className="text-muted text-center small">Loading...</p>
                    ) : (
                      participantList && (
                        <p className="text-muted text-center small">
                          Total <b>{participantList.length}</b>{" "}
                          {participantList.length > 1
                            ? "participants"
                            : "participant"}
                        </p>
                      )
                    )}
                  </div>
                </Card.Body>
              </Card>

              <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                  <Modal.Title>
                    {!loadingEvent &&
                      eventSnapshot &&
                      eventSnapshot.data().firstName && (
                        <h3 className="text-s-6 text-dark mb-0">
                          <>
                            {eventSnapshot.data().firstName}{" "}
                            <>
                              {eventSnapshot.data().lastName && (
                                <span>{eventSnapshot.data().lastName}</span>
                              )}
                            </>
                          </>
                        </h3>
                      )}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {!loadingEvent && eventSnapshot && (
                    <div className="card event-card border-0 h-100 p-4">
                      <div className="d-flex flex-column align-items-center">
                        {eventSnapshot.data().avatar && (
                          <div
                            style={{
                              background: `url(${getWhetherURLOrLocalFile(
                                eventSnapshot.data().avatar
                              )}) 0% 0% / cover no-repeat`,
                              height: "150px",
                              width: "150px",
                            }}
                            className="rounded-circle mx-5"
                          />
                        )}
                        {eventSnapshot.data().firstName && (
                          <h3 className="text-s-6 text-dark mt-3">
                            {eventSnapshot.data().firstName ? (
                              <>
                                {eventSnapshot.data().firstName}{" "}
                                <>
                                  {eventSnapshot.data().lastName && (
                                    <span>{eventSnapshot.data().lastName}</span>
                                  )}
                                </>
                              </>
                            ) : (
                              "Your name"
                            )}
                          </h3>
                        )}
                        <p className="mb-3 text-dark">
                          {eventSnapshot.data().email
                            ? eventSnapshot.data().email
                            : null}
                        </p>
                        <div className="d-flex mb-2">
                          {eventSnapshot.data().linkedinURL ? (
                            <>
                              <a
                                className="mr-3"
                                rel="noreferrer noopener"
                                target="_blank"
                                href={eventSnapshot.data().linkedinURL}
                              >
                                <FontAwesomeIcon
                                  icon={faLinkedin}
                                  className="text-primary"
                                  style={{ fontSize: 20 }}
                                />
                              </a>
                            </>
                          ) : null}

                          {eventSnapshot.data().twitterURL ? (
                            <>
                              <a
                                className="mr-3"
                                rel="noreferrer noopener"
                                target="_blank"
                                href={eventSnapshot.data().twitterURL}
                              >
                                <FontAwesomeIcon
                                  icon={faTwitterSquare}
                                  className="text-primary"
                                  style={{ fontSize: 20 }}
                                />
                              </a>
                            </>
                          ) : null}

                          {eventSnapshot.data().videoMeetingLink ? (
                            <a
                              className="mr-3"
                              rel="noreferrer noopener"
                              target="_blank"
                              href={eventSnapshot.data().videoMeetingLink}
                            >
                              <FontAwesomeIcon
                                icon={faVideo}
                                className="text-primary"
                                style={{ fontSize: 20 }}
                              />
                            </a>
                          ) : null}

                          {eventSnapshot.data().websiteURL ? (
                            <a
                              rel="noreferrer noopener"
                              target="_blank"
                              href={eventSnapshot.data().websiteURL}
                            >
                              <FontAwesomeIcon
                                icon={faLink}
                                className="text-primary"
                                style={{ fontSize: 20 }}
                              />
                            </a>
                          ) : null}
                        </div>
                      </div>
                      <div className="card-body h-100 p-0 bg-white">
                        <p className="mb-3 text-dark text-center">
                          {eventSnapshot.data().bio
                            ? parse(eventSnapshot.data().bio)
                            : null}
                        </p>
                      </div>
                    </div>
                  )}
                </Modal.Body>
              </Modal>

              <Modal
                show={showNM}
                onHide={handleCloseNM}
                backdrop="static"
                keyboard={false}
              >
                <Modal.Header closeButton>
                  <div className="d-flex align-items-center">
                    <UserAvatar imgSize={36} attendee={currentProfile} />
                    {/* <div
              className="border rounded-circle d-flex align-items-center justify-content-center mr-2"
              style={{ height: 30, width: 30 }}
            >
              <FontAwesomeIcon
                icon={faUserFriends}
                className="text-primary"
                style={{ fontSize: "16" }}
              />
            </div> */}
                    {currentProfile ? (
                      <div>
                        <p className="h6 mb-0">{currentProfile.displayName}</p>
                        <p className="small text-muted mb-0">
                          Networking request
                        </p>
                      </div>
                    ) : (
                      <p className="h6 mb-0">Networking request</p>
                    )}
                  </div>
                </Modal.Header>

                <Modal.Body>
                  <Form onSubmit={submitNetworkingRequest}>
                    {/* <Form.Group controlId="formBasicEmail">
              <Form.Label>Subject</Form.Label>
              <Form.Control 
                name="subject" 
                type="text" 
                placeholder="Enter subject" 
                value={subject}
                onChange={e => {
                  setSubject(e.target.value)
                  setSubjectErr(false)
                }}
               />
            </Form.Group>
            {subjectErr && <small className="text-danger">Please add a subject to understand the issue well</small>} */}

                    <Form.Group
                      className="mb-0"
                      controlId="exampleForm.ControlTextarea1"
                    >
                      <Form.Label>Enter your message</Form.Label>
                      <Form.Control
                        name="networkingMessage"
                        as="textarea"
                        rows={4}
                        onChange={(e) => {
                          setNetworkingMessage(e.target.value);
                          setNetworkingMessageErr(false);
                        }}
                        value={networkingMessage}
                      />
                    </Form.Group>
                    {networkingMessageErr && (
                      <small className="text-danger">
                        <b>Error</b>: Please add some message
                      </small>
                    )}

                    <Button variant="primary" type="submit" className="mt-3">
                      Submit
                    </Button>
                  </Form>

                  <div className="">
                    <small>
                      <b>Note:</b> Your name and email details will be sent with
                      this message.
                    </small>
                    {/* <div>
              <p>{!loadingMyDoc && myDoc.data().bio}</p>
              <p>{!loadingMyDoc && myDoc.data().linkedinURL}</p>
              <p>{!loadingMyDoc && myDoc.data().twitterURL}</p>
              <p>{!loadingMyDoc && myDoc.data().websiteURL}</p>
            </div> */}
                  </div>
                </Modal.Body>
              </Modal>
            </div>
            <div
              className="col-md-4 h-100 px-0 d-none d-md-block"
              style={{ overflow: "scroll" }}
            >
              <EventChat event_id={currentEvent?.id} />
            </div>
          </div>
        </div>
        {/* Chat Mobile view */}
        {showChat && (
          <div
            className="shadow-lg border border-muted"
            style={{
              height: "55vh",
              position: "fixed",
              bottom: "17vh",
              left: 10,
            }}
          >
            <EventChat event_id={currentEvent?.id} />
          </div>
        )}
        <div
          style={{
            position: "fixed",
            height: 45,
            width: 45,
            bottom: "10.5vh",
            left: 5,
          }}
          className="bg-primary rounded-circle d-block d-md-none"
        >
          <a
            className="d-flex align-items-center justify-content-center"
            onClick={() => setShowChat((prev) => !prev)}
            style={{
              height: 45,
              width: 45,
            }}
          >
            <FontAwesomeIcon
              className="text-white"
              icon={showChat ? faTimes : faComment}
              style={{ fontSize: 20 }}
            />
          </a>
        </div>
      </div>
    </React.Fragment>
  );
}

export default connect((state) => ({
  currentLanguage: state.currentLanguage,
  currentEvent: state.currentEvent,
  darkTheme: state.darkTheme,
}))(PeopleNetwork);
